<template>
  <div :class="getCurrentTheme()" :style="getCurrentStyle()">
    <div v-if="pageError || appError" class="constrain-width mobile card">
      <span class="app-error">
        <SnackbarPrompt icon="warning" variation="warning">{{
          pageError || appError
        }}</SnackbarPrompt></span
      >
    </div>
    <div v-else-if="appisLoading" class="constrain-width mobile card">
      <LoadingIndicator size="small" />
    </div>
    <!-- Mobile checkout -->
    <PageMobilePayment
      v-else-if="appType === pageViewTypes.mobilePayment"
      :key="pageViewTypes.mobilePayment"
    />
    <!-- Web onboarding -->
    <PageOnboarding
      v-else-if="appType === pageViewTypes.web"
      :key="pageViewTypes.web"
    />
    <!-- Web referral onboarding -->
    <PageOnboarding
      v-else-if="appType === pageViewTypes.referral"
      :key="pageViewTypes.referral"
    />
    <!-- Web partner onboarding -->
    <PageOnboarding
      v-else-if="appType === pageViewTypes.partnerOnboarding"
      :key="pageViewTypes.partnerOnboarding"
    />
    <!-- Therapist -client checkout -->
    <PageTherapistClient
      v-else-if="appType === pageViewTypes.therapistClient"
      :key="pageViewTypes.therapistClient"
    />
    <!-- Partner checkout -->
    <PagePartner
      v-else-if="appType === pageViewTypes.partnerCheckout"
      :key="pageViewTypes.partnerCheckout"
    />
  </div>
</template>
<script>
import PageOnboarding from "./Onboarding/PageOnboarding.vue";
import PageMobilePayment from "./Mobile/PageMobile.vue";
import PageTherapistClient from "./TherapistClient/PageTherapistClient.vue";
import PagePartner from "./Partner/PagePartner.vue";
import LoadingIndicator from "@/components/LoadingIndicator";
import SnackbarPrompt from "@/components/SnackbarPrompt";
import { MODULES } from "@/config";
import { PAGE_VIEW_TYPES } from "@/config";
import { mapGetters } from "vuex";
import classnames from "classnames";
import * as queryString from "query-string";

export default {
  data() {
    return {
      pageError: null,
      pageViewTypes: PAGE_VIEW_TYPES,
      allianzImageUrl: require("@/assets/icons/allianz-driving-background.jpg"),
    };
  },
  mounted() {
    this.setupApp();
  },
  components: {
    PageOnboarding,
    PageMobilePayment,
    PageTherapistClient,
    PagePartner,
    LoadingIndicator,
    SnackbarPrompt,
  },
  computed: {
    ...mapGetters(MODULES.APP, {
      appType: "getAppType",
      appisLoading: "getAppIsLoading",
      appError: "getAppError",
      pageData: "getPageDataByName",
      currentPage: "getCurrentPage",
    }),
  },
  methods: {
    setAppError(err) {
      this.pageError = err;
    },
    setupApp() {
      const { dispatch } = this.$store;

      const search = location.hash.replace("#/", "");
      const query = queryString.parse(search);

      delete query.i;
      location.hash = `#/?${queryString.stringify(query)}`;

      dispatch(`${MODULES.APP}/setupApp`, query).then(() => {
        if (query["referral_code"]) {
          dispatch(`${MODULES.APP}/getReferrerCode`, {
            referral_code: query.referral_code,
          });
        }
        this.setupTracking();
      });
    },
    setupTracking() {
      if (window?.analytics) {
        window.analytics.identify();
      }
      if (window?.dataLayer) {
        window.dataLayer.push({ event: "onboarding_started" });
      }
    },
    getCurrentTheme() {
      const baseClass = "main-container";

      if (this.appisLoading || !this.currentPage) {
        return baseClass;
      }

      const selectedPage = this.pageData(this.currentPage);

      if (!selectedPage) {
        this.setAppError(
          "Page not found.\nPlease contact ovrcome support: support@ovrcome.io"
        );

        return baseClass;
      }

      const mainContainer = classnames(baseClass, selectedPage.theme);

      return mainContainer;
    },
    getCurrentStyle() {
      const selectedPage = this.pageData(this.currentPage);
      if (
        selectedPage &&
        selectedPage.id.includes("partnership-allianz-page")
      ) {
        return {
          backgroundImage: "url(" + this.allianzImageUrl + ")",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        };
      } else {
        return "";
      }
    },
  },
};
</script>
